<template>
    <div class="full-wdith-editor">
      <el-row class="row">

        <el-col :span="6"  v-for="(v, i) in paymentList" :key="i + new Date().getTime()" >
          <div class="thumbnail provider" @click="chengHallPaymentType(v,i)" style="padding: 10px 15px;cursor: pointer;font-size: 18px;font-weight: bold;border: 1px solid transparent;box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);">
            <div class="paylogo" data-key="${v.paymentMethod}" :style="{'background-image': `url(${getPaymentLogo(v)})`,'background-size': 'contain','width':'100%','padding-top':'100%','background-repeat':'no-repeat','background-position':'center'}">
              <img v-if="v.active" style="width:50%;  margin-top:-75%; margin-left: 25%;" :src="`${publicPath}/static/images/choose.png?v=20241113`"/>

            </div>
          </div>
        </el-col>
        <el-col :span="24">

          <el-empty :description="i18n.tkey('lang_temporary_no_data')" v-show="paymentList.length === 0">

          </el-empty>
          <br>
          <el-button type="primary" @click="btnChagePayment()"  tkey="確認">{{i18n.tkey("lang_confirm_text")}}</el-button>
        </el-col>
      </el-row>

    </div>
</template>

<script setup>

import {inject, ref, computed, onMounted} from "vue";
import eshopopeeApi from "@/request/eshopopeeApi";
import myUtil from "@/util/util";
import util from "@/util/util";


const props = defineProps(["hallAddinfo28"])
const emits = defineEmits(["chengSelectPayment"])

const i18n = inject("i18n")
const publicPath = process.env.BASE_URL
const paymentList = ref([])
const shopCompany = ref({})
const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

function getPaymentList() {
  const request = eshopopeeApi.getPaymentList
  const params = request.getParams()

  params.CompanyCode = shopCompany.value.acccompanycode

  request.send(params, getListCallback)
}
function chengHallPaymentType(v,i) {
  //console.log($obj.)
  // $(".thumbnail").removeClass("active")
  // $(".thumbnail").find('img').hide()
  // $(obj).find('img').css('display', 'block');
  // $(obj).addClass("active")
  //
  // var network = $(obj).find(".paylogo").attr('data-key');
  if( paymentList.value[i].active == true){
    paymentList.value[i].active = false
  }else {
    paymentList.value[i].active = true
  }
}
function getPaymentLogo(obj){
  var imgPath = ""
  if("PayPal"===obj.paymentMethod){
    return publicPath+"static/images/paypal-payments.png?v=20241113"
  }else if("PaymentAsia"===obj.paymentMethod){
    return publicPath+"static/images/paymentAisa-payments.png?v=20241113"
  }else if("WeChat Pay"===obj.paymentMethod){
    return publicPath+"static/images/wechat-pay.png?v=20241113"
  }else if("FPS"===obj.paymentMethod){
    return publicPath+"static/images/fps-en.png?v=20241113"
  }else if("Alipay"===obj.paymentMethod){
    return publicPath+"static/images/alipay.png?v=20241113"
  }else if("Custom"===obj.paymentMethod){
    return publicPath+"static/images/visa-master-apple-google.png?v=20241113"
  }else if("Bank Transfer"===obj.paymentMethod){
    return publicPath+"static/images/visa-master-apple-google.png?v=20241113"
  }
  return imgPath
}


  function getListCallback(res) {
  if (myUtil.isNotEmpty(res)){
    paymentList.value = res
    if(util.isNotEmpty(props.hallAddinfo28)){
      for (let i = 0; i < paymentList.value.length; i++) {
        if(props.hallAddinfo28.includes(paymentList.value[i].paymentMethod)){
          paymentList.value[i].active = true;
        }
      }

    }

  }else{
    paymentList.value = []
  }
}

function btnChagePayment(){
  var addinfo28 = ""
  for (let i = 0; i < paymentList.value.length; i++) {
    if(paymentList.value[i].active){
      addinfo28 = addinfo28+`${paymentList.value[i].paymentMethod},`
    }
  }
  emits('chengSelectPayment', addinfo28)
}

onMounted(() => {
  shopCompany.value = getShopCompanyObj()
  getPaymentList()
})

</script>

<style scoped>
.full-wdith-editor {
    width: 100%;
}

.editor-title-toolbar {
    text-align: center;
    position: relative;
    margin-bottom: 32px;
}

.editor-title-toolbar .return-btn {
    position: absolute;
    left: 0;
    top: 5px;
}

.editor-title-toolbar .right-operation-btn {
    position: absolute;
    right: 0;
    top: 0;
}
.paylogo{
  display: flex;
}

</style>